import { Box, Button, Text, useToggle } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import FiltersComponent from 'modules/core/components/Filters'
import Popover from 'modules/core/components/Popover'
import type FiltersForm from 'modules/core/lib/forms/Filters'
import i18n from 'modules/core/lib/i18n'

interface Props {
  form: FiltersForm
  showFilterByTeam?: boolean
  showFilterByTimeoffSupervisor?: boolean
  showFilterByDirectManagedEmployee?: boolean
  showFilterByManagedEmployee?: boolean
  showFilterByAway?: boolean
  showFilterByAwayThisMonth?: boolean
  canSeeClockedIn: boolean
}

const Filters = ({
  form,
  showFilterByTeam,
  showFilterByTimeoffSupervisor,
  showFilterByDirectManagedEmployee,
  showFilterByManagedEmployee,
  showFilterByAway,
  showFilterByAwayThisMonth,
  canSeeClockedIn,
}: Props) => {
  const [open, toggle] = useToggle()
  const field = form.get('filterBy')
  const isDirty = field.isDirty

  return (
    <Popover
      attachment="top left"
      targetAttachment="bottom center"
      size="big"
      toggle={toggle}
      open={open}
    >
      <Button
        type={isDirty ? 'primary' : 'secondary'}
        onClick={toggle(true)}
        iconName={open ? 'chevron-up' : 'chevron-down'}
      >
        {i18n.t('filters.title')}
      </Button>
      <Box padding="s24" gap="s16">
        <Box gap="s4" textAlign="left">
          <Text.Normal weight="medium">{i18n.t('filters.filter.title')}</Text.Normal>
          <Text.Normal>{i18n.t('filters.filter.description')}</Text.Normal>
        </Box>
        <FiltersComponent
          showFilterByTeam={showFilterByTeam}
          showFilterByTimeoffSupervisor={showFilterByTimeoffSupervisor}
          showFilterByDirectManagedEmployee={showFilterByDirectManagedEmployee}
          showFilterByManagedEmployee={showFilterByManagedEmployee}
          showFilterByAway={showFilterByAway}
          showFilterByAwayThisMonth={showFilterByAwayThisMonth}
          field={field}
          width="full"
          none={i18n.t('filters.filter.none')}
          canSeeClockedIn={canSeeClockedIn}
        />
      </Box>
    </Popover>
  )
}

export default observer(Filters)
